export default __webpack_public_path__ + "static/media/Light.9649f6b3.woff2";